import React, { useState } from 'react';

// LISTA DE ESTADOS (UF)
const estados = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];

// LISTA DE CIDADES POR ESTADO (exemplo - idealmente viria de uma API ou JSON)
const cidadesPorEstado = {
  MT: ['Sinop', 'Cuiabá', 'Sorriso', 'Rondonópolis', 'Várzea Grande'],
  SP: ['São Paulo', 'Campinas', 'Santos', 'Ribeirão Preto'],
  RJ: ['Rio de Janeiro', 'Niterói', 'Petrópolis'],
  // adicione os demais estados conforme necessário
};

const FiltroLocalAtuacao = ({ filtros, onLocalizacaoChange }) => {
  const [editando, setEditando] = useState(false);

  const handleEstadoChange = (e) => {
    const novoEstado = e.target.value;
    onLocalizacaoChange({ estado: novoEstado, cidade: '' });
  };

  const handleCidadeChange = (e) => {
    const novaCidade = e.target.value;
    onLocalizacaoChange({ estado: filtros.estado, cidade: novaCidade });
  };

  // Exemplo de como você poderia buscar as cidades dinamicamente
  // useEffect(() => {
  //   if (filtros.estado) {
  //     // Chamar uma API aqui para obter as cidades do estado
  //     // Ex: fetch(`api/cidades?estado=${filtros.estado}`)
  //   }
  // }, [filtros.estado]);

  const cidades = cidadesPorEstado[filtros.estado] || [];

  return (
    <div>
      {!editando ? (
        <div className="flex justify-between items-center mb-4">
          <span className="text-sm text-gray-800 font-medium">
            Você atua em:{' '}
            <strong>
              {filtros.cidade || 'Não definido'} - {filtros.estado || 'UF'}
            </strong>
          </span>
          <button
            onClick={() => setEditando(true)}
            className="text-blue-600 text-sm font-medium hover:underline"
          >
            Alterar
          </button>
        </div>
      ) : (
        <div className="flex gap-2 mb-4">
          <select
            name="estado"
            value={filtros.estado || ''}
            onChange={handleEstadoChange}
            className="w-1/2 border border-gray-300 rounded-xl p-2 text-sm text-black bg-white"
          >
            <option value="">Selecione o estado</option>
            {estados.map((uf) => (
              <option key={uf} value={uf}>
                {uf}
              </option>
            ))}
          </select>

          <select
            name="cidade"
            value={filtros.cidade || ''}
            onChange={handleCidadeChange}
            className="w-1/2 border border-gray-300 rounded-xl p-2 text-sm text-black bg-white"
            disabled={!filtros.estado}
          >
            <option value="">Selecione a cidade</option>
            {cidades.map((cidade) => (
              <option key={cidade} value={cidade}>
                {cidade}
              </option>
            ))}
          </select>
          <button
            onClick={() => setEditando(false)}
            className="px-4 py-2 bg-gray-200 text-gray-800 rounded-xl font-semibold"
          >
            OK
          </button>
        </div>
      )}
    </div>
  );
};

export default FiltroLocalAtuacao;
